import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const SHOP_SEARCH_PARAMETERS_MODAL_LAUNCHER_LEGACY_FIELD_ORDER = [
  "force_launch",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopSearchParametersModalLauncherBlockDescriptor:
    _generatedShopSearchParametersModalLauncherBlockDescriptor,
  shopSearchParametersModalLauncherBlockBlocDefinition,
  shopSearchParametersModalLauncherBlockDashboardLayout,
  shopSearchParametersModalLauncherBlockConfig,
  shopSearchParametersModalLauncherBlockResolveConfig,
  shopSearchParametersModalLauncherBlockProperties,
} = doodBlockConfig(
  {
    name: "Modal launcher / Shop search parameters",
    componentType: "ShopSearchParametersModalLauncherBlockComponent",
    category: "system",
    description: "Automatically launches the shop search parameters modal.",
    keywords: ["modal", "shop", "search"],
    sharedFields: {},
  },

  () => ({
    force_launch: propertyValue({
      type: "checkbox",
      value: false,
      options: {
        label:
          "pages.blocks.shop-search-parameters-modal-launcher.force-launch.label",
        help: "pages.blocks.shop-search-parameters-modal-launcher.force-launch.help",
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label:
          "pages.blocks.shop-search-parameters-modal-launcher.tab.content.label",
        fieldsets: [
          {
            legend:
              "pages.blocks.shop-search-parameters-modal-launcher.fieldset.opening.label",
            fields: ["force_launch"],
          },
        ],
      },
    ],
  }),
);

export function shopSearchParametersModalLauncherBlockDescriptor(): IBlockDescriptor;
export function shopSearchParametersModalLauncherBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopSearchParametersModalLauncherBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopSearchParametersModalLauncherBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedShopSearchParametersModalLauncherBlockDescriptor,
    shopSearchParametersModalLauncherBlockProperties,
    fieldOrder,
  );
}

export {
  shopSearchParametersModalLauncherBlockBlocDefinition,
  shopSearchParametersModalLauncherBlockDashboardLayout,
  shopSearchParametersModalLauncherBlockConfig,
  shopSearchParametersModalLauncherBlockResolveConfig,
  shopSearchParametersModalLauncherBlockProperties,
};

export type ShopSearchParametersModalLauncherBlockConfig = typeof shopSearchParametersModalLauncherBlockConfig;
